export default `p.z-=2.5;
    float s = 3.;
    float e = 0.;
    for(int j=0;j++<8;)
      s*=e=3.8/clamp(dot(p,p),0.,2.),
      p=abs(p)*e-vec3(1.0,15.0,1.0);
    return length(cross(p,vec3(1.0,1.0,-1.0)*.577))/s;
  }`